// extracted by css-extract-rspack-plugin
export default {"dialogContent":"dialog-module__dialogContent___q97wH","heading":"dialog-module__heading___Mbon2","button":"dialog-module__button___zmcdc"};